import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type CharacteristicCountResp as SchemaCharacteristicCountResp } from '../schemas/CharacteristicCountResp';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Characteristics
 */
export const GetCharacteristicsCountContentType = '' as const;
export type GetCharacteristicsCountRequest = void;
export type GetCharacteristicsCountResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful retrieval of data
     */
    '200': {
        'application/json': SchemaCharacteristicCountResp;
    };
};
export type GetCharacteristicsCountResponseSuccess = GetCharacteristicsCountResponses['200']['application/json'];
export type GetCharacteristicsCountSearchParams = undefined;
export type GetCharacteristicsCountPathParameters = undefined;
export const GetCharacteristicsCountUrl = '/characteristics/counts' as const;
export const GetCharacteristicsCountMethod = 'GET' as const;
export const getGetCharacteristicsCountUrl = (_params?: GetCharacteristicsCountPathParameters) =>
    GetCharacteristicsCountUrl;
